import React from 'react';
import { useContent } from '../context/ContentContext';

export const MARQUEE_DEFAULTS = {
  items: [
    'PLEUROTUS OSTREATUS', 'LENTINULA EDODES', 'HERICIUM ERINACEUS', 'PLEUROTUS DJAMOR',
    'STÉRILISATION 121 °C', 'FILTRATION 0,2 µ', 'SALLE ISO-5', 'GÉNÉTIQUE F3',
    'EXPÉDITION 48 H', 'MAÎTRISE DU CLIMAT',
  ],
};

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((t, i) => (
      <span key={`${t}-${i}`} className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-slate-300">
        <span className="px-8">{t}</span>
        <span className="text-neon/70">◆</span>
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const c = useContent('marquee', MARQUEE_DEFAULTS);
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-neon/15 bg-panel/40 py-4">
      <div className="marquee-track flex w-max">
        <Row items={c.items} />
        <Row items={c.items} />
      </div>
    </div>
  );
};

export default Marquee;
